"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GA_SETTINGS_PROP_FIXTURE = void 0;
var GA_SETTINGS_PROP_FIXTURE = {
  guestPartnerId: 'find_better_fake_data',
  isActive: true,
  userPartnerId: 'de57256e_a1606badad63373897f4856e6ea677d5'
};
exports.GA_SETTINGS_PROP_FIXTURE = GA_SETTINGS_PROP_FIXTURE;
//# sourceMappingURL=fixtures.js.map